import React, {useEffect, useState} from "react";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    font-size: 10px;
    margin: 0 20px 0 20px;
    color: #516F90;
`;

type Props = {
    conversation: any;
};

function TypingIndicator(props: Props) {
    const {conversation} = props;
    const [isTyping, setIsTyping] = useState({state: false, user: ""});
    useEffect(() => {
        const abortController = new AbortController();
        if (conversation) {
            conversation.on("typingStarted", async (member) => {
                let user = await member.getUser();
                //@ts-ignore
                setIsTyping({state: true, user: user.friendlyName});
            });

            conversation.on("typingEnded", async (member) => {
                let user = await member.getUser();
                //@ts-ignore
                setIsTyping({state: false, user: user.friendlyName});
            });
        }

        return () => {
            if (conversation) {
                conversation.removeListener("typingStarted", () => abortController.abort());
                conversation.removeListener("typingEnded", () => abortController.abort());
            }
        };
    }, [conversation]);

    if (!isTyping.state) return null;

    return <Container>{`${isTyping.user} is typing ...`}</Container>;
}

export default TypingIndicator;
